import { PartnerCards } from "components";
import type { PartnerCardsProps } from "components/PartnerCards";
import type { ReactStoryblokComponent } from "types/storyblok";

export const PartnerCardsAdapter = ({ blok: { cards, itemsInRow } }: ReactStoryblokComponent<PartnerCardsProps>) => (
  <PartnerCards cards={cards} itemsInRow={itemsInRow} />
);
